import React from 'react';
import { Select } from 'antd';
import { SimulatorOfferModel, RiderPackageModel, IdentityType, CustomerModel, CustomerPersonalModel } from '../models/superbit-api-models'
import { SimulatorModel } from '../models/SimulatorModel'
import { ManulApiModel } from '../models/ManulApiModel'
import '../assets/css/_car-policy-production_popup.css'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { IDNameDescriptionDictionary, AutocompleteData } from '../models/Site'
import PersonalDetailsDriver from './_PersonalDetailsDriver';
import { OfferProductionModel } from '../models/OfferProductionModel';
import CarAndDriversDetails from './CarAndDriversDetails';
import { cloneDeep, set } from "lodash";
import InsuraceAndCoversDetails from './InsuraceAndCoversDetails';
import { GetBanks } from '../models/CacheModel';
import AttachedDocuments from './AttachedDocuments';
import PaymentDetailsOfProduction from './PaymentDetailsOfProduction';
import { datePresentation } from '../components/util';
import { connect } from 'react-redux';
import { RootState } from '../app-context/store';
import SavingPopUp from '../components/SavingPopUp';
import moment from 'moment';
import DateOfProductionIsLate from '../components/DateOfProductionIsLate';
import PleaseWaitLayer from '../components/_PleaseWaitLayer';
import OfferProductionResponseModel from '../simulator/_OfferProductionResponseModel'
import { DocumentTypeModel, ElementaryPolicyModel } from '../models/superbit-api-models';
import { OfferProductionSuccessNavigateToLead } from './OfferProductionSuccessNavigateToLead';
import { setReloadLeads } from '../app-context/leadsSlice';
import UpdateClientDetails from './UpdateClientDetails';
import { CustomerCardModel } from '../models/CustomerCardModel';
import { GeneralDataModel } from '../models/GeneralDataModel';

const validationPersonalDetailsDriver = ['ownerFirstName', 'ownerLastName', 'ownerDateOfBirth', 'ownerIdentifier', 'ownerIdentityIssueDate', 'city', 'street', 'houseNumber', 'apartmentNumber', 'mailbox', 'postalCode', 'number', 'emailAddress'];

interface TransformedBankData {
    BankName: string;
    branchCode: number[];
}

type Props = {
    offer: SimulatorOfferModel | null;
    riders?: RiderPackageModel[];
    closeProduction: any;
    showLog: any;
    agreementData: {
        termsOfService: boolean;
        privacyPolicy: boolean;
        marketingEmails: boolean;
    };
    onGoToSimulatorClick?: (e: string) => void;
    onEdit?: (e: string) => void;

    // redux
    setReloadLeads: (reload: boolean) => void;
};
type State = {
    offer: any | null;
    customerId?: string;
    productionData: any | null;
    oldProductionData: any | null;
    riders: RiderPackageModel[];
    InsuranceTypes: IDNameDescriptionDictionary;
    IdentityTypes: IDNameDescriptionDictionary;
    AuthorizedToDrive: IDNameDescriptionDictionary;
    Geder: IDNameDescriptionDictionary;
    MaritalStatus: IDNameDescriptionDictionary;
    PassedTypeOfInsurance: IDNameDescriptionDictionary;
    VehicleOwnership: IDNameDescriptionDictionary;
    ImpairmentDeductible: IDNameDescriptionDictionary;
    RenovationAgentsOffice: IDNameDescriptionDictionary;
    RenovationCompany: IDNameDescriptionDictionary;
    CitiesList: Array<AutocompleteData>;
    CitiesForSearch: Array<AutocompleteData>;
    Streets: [];
    SelectedTab: string;
    open: boolean;
    message: string;
    validationErrors: { [key: string]: string };
    allBanks: any[];
    showModel: boolean;
    log: string;
    showSavingModel: boolean;
    carInfo: any;    
    loading: boolean;
    statusMessege: string;
    navigatePath: string;
    citiesListData: any[];
    streetsListData: any[];
    agreementData: any;
    agreementAlert: boolean;
    position: any;
    isDragging: boolean;
    offset: any;
    elementaryPolicyDocuments: Array<{
        createdDate: string;
        documentType: DocumentTypeModel;
        elementaryPolicy: any;
        elementaryPolicyDocumentType: number;
        elementaryPolicyId: string;
        filePath: string;
        fileSize: string;
        id: string;
        updatedDate: string;
        user: any;
        userId: string;
    }>;
    usersSignatures: [];
    saveLoading: boolean;
    saveProductionAndSuccess: boolean;
    hasClickToSaveAndProduction: boolean;
    callingContactChecked: boolean;
    isClient: boolean;
    clientData: CustomerPersonalModel | null;
};



class OfferProduction extends React.Component<Props, State> {

    private birthDateRef: React.RefObject<DatePicker>;
    private identifierDateRef: React.RefObject<DatePicker>;
    private mainLicenseDateRef: React.RefObject<DatePicker>;
    private youngLicenseDateRef: React.RefObject<DatePicker>;

    offerProductionModel: OfferProductionModel = new OfferProductionModel();

    GUID_EMPTY = '00000000-0000-0000-0000-000000000000';

    constructor(props: any) {
        super(props);

        this.state = {
            offer: this.props.offer,
            log: "",
            productionData: null,
            oldProductionData: null,
            riders: [],
            InsuranceTypes: new IDNameDescriptionDictionary(),
            IdentityTypes: new IDNameDescriptionDictionary(),
            AuthorizedToDrive: new IDNameDescriptionDictionary(),
            Geder: new IDNameDescriptionDictionary(),
            PassedTypeOfInsurance: new IDNameDescriptionDictionary(),
            MaritalStatus: new IDNameDescriptionDictionary(),
            VehicleOwnership: new IDNameDescriptionDictionary(),
            ImpairmentDeductible: new IDNameDescriptionDictionary(),
            RenovationAgentsOffice: new IDNameDescriptionDictionary(),
            RenovationCompany: new IDNameDescriptionDictionary(),
            CitiesList: [],
            CitiesForSearch: [],
            Streets: [],
            SelectedTab: "tab-content-1",
            open: false,
            message: '',
            validationErrors: {},
            allBanks: [],
            showModel: false,
            showSavingModel: false,
            carInfo: {},            
            loading: false,
            statusMessege: '',
            navigatePath: '',
            citiesListData: [],
            streetsListData: [],
            agreementData: this.props.agreementData,
            agreementAlert: false,
            position: { x: (0.2*1000), y: 30 },
            isDragging: false,
            offset: { x: 0, y: 0 },
            elementaryPolicyDocuments: [],
            usersSignatures: [],
            saveLoading: false,
            saveProductionAndSuccess: false,
            hasClickToSaveAndProduction: false,
            callingContactChecked: false,
            isClient: false,
            clientData: null,
        };
        this.birthDateRef = React.createRef<DatePicker>();
        this.identifierDateRef = React.createRef<DatePicker>();
        this.mainLicenseDateRef = React.createRef<DatePicker>();
        this.youngLicenseDateRef = React.createRef<DatePicker>();
    }

    async componentDidMount() {
        await this.loadOfferById();
        await this.load();
        await this.checkIfIsClient();
        
    }

    async checkIfIsClient() {

        console.log('checkIfIsClient-productionData', this.state.productionData)
        if (this.state.productionData && this.state.productionData.ownerIdentifier) {
            const customerDetails: any = await new SimulatorModel().getCustomerDetailsById(this.state.productionData.ownerIdentifier);
            console.log('checkIfIsClient-customerDetails', customerDetails)
            if(customerDetails && customerDetails.customer && customerDetails.customer.id){
                console.log('checkIfIsClient-customerDetails id', customerDetails.customer.id)
                const customerCardData = await new CustomerCardModel().getCustomerCardDetails(customerDetails.customer.id);
                console.log('checkIfIsClient-customerCardData', customerCardData)
                if (customerCardData && customerCardData.personalData) {
                    this.setState({ clientData: customerCardData.personalData});
                } else {
                    this.setState({ clientData: null });
                }
            }
        }
    }

    async load() {
        this.setState({
            InsuranceTypes: await new SimulatorModel().getInsuranceTypes(),
            AuthorizedToDrive: await new SimulatorModel().getAuthorizedToDriveItems(),
            Geder: await new SimulatorModel().getGenderTypes(),
            PassedTypeOfInsurance: await new SimulatorModel().getPassedTypeOfInsurance(),
            MaritalStatus: await new SimulatorModel().getMaritalStatus(),
            VehicleOwnership: await new SimulatorModel().getVehicleOwnership(),
            ImpairmentDeductible: await new SimulatorModel().getImpairmentDeductible(),
            RenovationAgentsOffice: await new SimulatorModel().getRenovationAgentsOffice(),
            RenovationCompany: await new SimulatorModel().getRenovationCompany(),
            IdentityTypes: await new SimulatorModel().getIdentityTypes(),
            CitiesList: await new ManulApiModel().GetCities(),
            usersSignatures: await this.offerProductionModel.getUserByRoleId(),
        }, () => this.loadBankData());

    }

    loadData = async (value: string) => {
        console.log('loadData', value);
        if (this.props.offer && this.props.offer.id) {
            const offerDataTemp = await this.offerProductionModel.simulatorLoadProduction(this.props.offer.id, value);
            
            await this.setTempData(offerDataTemp);
                await this.setState({ productionData: offerDataTemp});
            if (offerDataTemp && offerDataTemp.elementaryPolicyDocuments) {
                await this.setState({ elementaryPolicyDocuments: [...offerDataTemp.elementaryPolicyDocuments]});
            }

        }
    }

    loadBankData = async () => {
        const bankDict: Record<string, number[]> = {};
        let allBanksData = [];
        try {
            allBanksData = await new GeneralDataModel().getBankList();
        } catch (error) {
            console.error('Error fetching bank data:', error);
            allBanksData = [];
        }
        console.log('allBanksData', allBanksData)
        let data = [];
        allBanksData.forEach((item: any) => {
            const { Bank_Name, Branch_Code, Branch_Address, Branch_Name } = item;
            if (!bankDict[Bank_Name]) {
                bankDict[Bank_Name] = [];
            }
            bankDict[Bank_Name].push({ 'Branch_Code': Branch_Code, 'Branch_Address': Branch_Address + " " + Branch_Name } as any);
        });

        const transformedData: TransformedBankData[] = Object.entries(bankDict).map(
            ([BankName, branchCodes]) => {
                branchCodes = (branchCodes as any).sort((a: any, b: any) => a.Branch_Code - b.Branch_Code);
                return {
                    BankName,
                    branchCode: branchCodes,
                };
            }
        );

        if (this.state.productionData && this.state.productionData.elementaryPolicyDocuments) {
            this.setState({ elementaryPolicyDocuments: [...this.state.productionData.elementaryPolicyDocuments] });
        }

        // if (this.state.productionData && this.state.productionData.ownerCustomer && this.state.productionData.ownerCustomer.customerAddresses
        //     && this.state.productionData.ownerCustomer.customerAddresses.length > 0 && this.state.productionData.ownerCustomer.customerAddresses[0].city) {
        //     const streetAutocomplete = await new SimulatorModel().getStreetsAutocomplete(this.state.productionData.ownerCustomer.customerAddresses[0].city);
        //     console.log('streetAutocomplete', streetAutocomplete)
        //     this.setStreetsState([...streetAutocomplete.map((street: any) => street.value)])
        // }

        const citiesArray = this.state.CitiesList.map((city) => city.val);

        this.setState({ allBanks: transformedData, citiesListData: citiesArray, loading: true });
    }

    async loadOfferByIdAfterUpdateClientData(identifeir: string ) {

        if (identifeir && identifeir.length > 0 ) {
            // const offerDataTemp = await this.offerProductionModel.getOpenProduction(this.props.offer.id);
            const customerDetails: any = await new SimulatorModel().getCustomerDetailsById(identifeir);
            
            await this.updateClientInfoInOfferData(customerDetails);
        }
    }

    updateClientInfoInOfferData = async (customerDetails: any) => {
        console.log("updateClientInfoInOfferData-customerDetails", customerDetails);
        if (customerDetails && customerDetails.customer) {
            const productionData = this.state.productionData;
            productionData.ownerFirstName = customerDetails.customer.firstName;
            productionData.ownerLastName = customerDetails.customer.lastName;
            productionData.ownerIdentityType = customerDetails.customer.identityType;
            productionData.ownerIdentifier = customerDetails.customer.identifier;
            productionData.ownerIdentityIssueDate = customerDetails.customer.identityIssueDate;
            productionData.ownerDateOfBirth = customerDetails.customer.dateOfBirth;
            productionData.ownerGender = customerDetails.customer.gender
            productionData.ownerMaritalStatus = customerDetails.customer.maritalStatus;
            productionData.ownerContactDetails = customerDetails.customer.customerContactDetails[0];
            productionData.ownerAddress = customerDetails.customer.customerAddresses[0];
            await this.setState({ productionData: productionData, isClient: false });
        }
    }

    async componentDidUpdate(prevProps: Props, prevState: State) {
        if (prevProps.offer !== this.props.offer && this.props.offer && this.props.offer.id) {
            this.loadOfferById();
        }
    };

    async loadOfferById() {
        console.log("this.props.offer", this.props.offer);

        if (this.props.offer && this.props.offer.id) {
            const offerDataTemp = await this.offerProductionModel.getOpenProduction(this.props.offer.id);

            await this.setTempData(offerDataTemp);
        }
    }

    async setTempData(offerDataTemp: any) {
        if (offerDataTemp) {
            // First update state

            // set time to 08:00 if endDate is after two days from now
            if (offerDataTemp.endDate) {
                const endDate = new Date(offerDataTemp.endDate);
                const startDate = new Date(offerDataTemp.startDate);
                const twoDaysFromNow = new Date();
                twoDaysFromNow.setDate(twoDaysFromNow.getDate() + 2);
                if (startDate > twoDaysFromNow) {
                    console.log("endDate, startDate > twoDaysFromNow", endDate, startDate, twoDaysFromNow, startDate > twoDaysFromNow);
                    console.log("endDate, before setHours", offerDataTemp.endDate);
                    endDate.setHours(8, 0, 0, 0);
                    let endDateStr = moment(endDate).format("YYYY-MM-DDTHH:mm:ss");
                    console.log("endDate, after setHours", endDateStr);
                    offerDataTemp.endDate = endDateStr;
                }
            }
            this.setState({
                riders: this.props.riders || [],
                offer: offerDataTemp.offer,
                productionData: cloneDeep(offerDataTemp),                
                oldProductionData: cloneDeep(offerDataTemp)
            }, async () => {
                const productionData = this.state.productionData;

                if (productionData.ownerIdentifier && productionData.ownerIdentifier.length > 0) {
                    try {
                        const customerDetails: any =
                            await new SimulatorModel().getCustomerDetailsById(productionData.ownerIdentifier);

                        if (customerDetails && customerDetails.customer) {
                            this.setState({ customerId: customerDetails.customer.id });

                            // 
                            console.log(" setTempData-productionData", productionData);
                            console.log(" setTempData-customerDetails", customerDetails);

                            if(!productionData.ownerIdentityType || productionData.ownerIdentityType === 0){
                                productionData.ownerIdentityType = customerDetails.customer.identityType;
                            }
                            if(!productionData.ownerFirstName || productionData.ownerFirstName === ''){
                                productionData.ownerFirstName = customerDetails.customer.firstName;
                            }
                            if(!productionData.ownerLastName || productionData.ownerLastName === ''){
                                productionData.ownerLastName = customerDetails.customer.lastName;
                            }
                            if(!productionData.ownerMaritalStatus || productionData.ownerMaritalStatus < 0){
                                productionData.ownerMaritalStatus = customerDetails.customer.maritalStatus;
                            }
                            if(!productionData.ownerGender || productionData.ownerGender < 0){
                                productionData.ownerGender = customerDetails.customer.gender;
                            }
                            if(!productionData.ownerIdentifier || productionData.ownerIdentifier === ''){
                                productionData.ownerIdentifier = customerDetails.customer.identifier;
                            }


                            const bDate = new Date(customerDetails.customer.dateOfBirth);
                            if(!productionData.ownerDateOfBirth || productionData.ownerDateOfBirth === null ||
                                productionData.ownerDateOfBirth === '0001-01-01T00:00:00'
                            ){
                                productionData.ownerDateOfBirth = bDate;
                            }

                            const iDate = new Date(customerDetails.customer.identityIssueDate);
                            productionData.ownerIdentityIssueDate = iDate;

                            productionData.ownerGender = customerDetails.customer.gender;
                            productionData.ownerContactDetails = customerDetails.customer.customerContactDetails[0];
                            productionData.ownerAddress = customerDetails.customer.customerAddresses[0];

                            await this.setState({ productionData: productionData });
                        }

                    } catch (err) {
                        console.error("Error loading customer details:", err);
                    }
                }

                console.log("this.state.productionData", this.state.productionData);
            });
        }
    }


    getInsuranceCompany = () => {
        if (this.state.productionData != null && this.state.productionData.insuranceCompanyRoute.insuranceCompany != null) {
            var id = this.state.productionData.routeId;
            var name = this.state.productionData.insuranceCompanyRoute.insuranceCompany.name;
            var routeName = this.state.productionData.insuranceCompanyRoute.comment;
            if (this.state.productionData.insuranceCompanyRoute.insuranceCompany.name == "הראל" && this.state.productionData.offer.additionalDetails != null) {
                if (this.state.productionData.offer.additionalDetails.indexOf('coverage10000\':true') != -1 ) {
                    routeName += " 10000";
                }
            }
            return name + " - " + routeName + " " + id;
        }
        return "";
    }

    closeProduction = () => {
        //
        this.props.closeProduction();
    }

    loadCities = (event: any) => {
        var city = "";
        if (typeof event === 'string')
            city = event;
        else
            city = event.currentTarget.innerHTML;
        var cities = this.state.CitiesList;
        cities = cities.filter(x => x.label != null && x.label.indexOf(city) > -1)
        this.setState({ CitiesForSearch: cities });
    }

    validateIdentifier(name: string, id: string) {
        var lead = this.state.productionData;
        // debugger
        if (lead && lead.ownerIdentityType == 1 && name == 'ownerIdentifier' || name == 'identifierMainDriver' || name == 'identifierYoung') {
            const idIsValid = this.isValidIsraeliId(id);
            console.log('idIsValid =================', idIsValid)
            return idIsValid;
            // return /^\d{9}$/.test(id);
        } else {
            let newId = parseInt(id);
            return /^\d{9}$/.test(newId as any);
        }
    };

    isValidIsraeliId(id: string): boolean {
        // Check if the input is a string and has 9 digits
        if (!/^\d{9}$/.test(id)) return false;

        // Convert the ID number to an array of digits
        const digits = id.split('').map(Number);

        // Calculate the sum of the digits
        let sum = 0;
        for (let i = 0; i < 8; i++) {
            let digit = digits[i];
            if (i % 2 === 0) {
                // For even indices, multiply the digit by 1
                sum += digit;
            } else {
                // For odd indices, multiply the digit by 2 and add the digits of the result
                sum += Math.floor(digit * 2 / 10) + (digit * 2) % 10;
            }
        }

        // The ninth digit (check digit)
        const checkDigit = digits[8];

        // Validate the check digit
        return (sum + checkDigit) % 10 === 0;
    }

    openTab = (tabName: string) => {
        this.setState({ SelectedTab: tabName });
    }

    calcRiders = () => {

        var riders = 0;
        if (this.state.productionData != null && this.state.productionData.offer != null && this.state.productionData.offer.riders != null && this.state.productionData.offer.riders.length > 0) {

            var allRiders = this.state.productionData.offer.riders.map((x: any) => x.price).reduce(function (a: any, b: any) { return a != null && b != null ? a + b : 0; });
            if (allRiders != null) {
                riders = allRiders;

            }


        }
        return riders;
    }

    checkIfIdentifierExist = async (value: any) => {
        if (value.length > 7 && value.length < 10) {

            const customerDetails: any = await new SimulatorModel().getCustomerDetailsById(value);
            if (customerDetails && customerDetails.customer) {

                const data = this.state.productionData;


                if (data) {
                    data.ownerIdentityType = customerDetails.customer.identityType;
                    data.ownerFirstName = customerDetails.customer.firstName;
                    data.ownerLastName = customerDetails.customer.lastName;
                    data.ownerIdentifier = customerDetails.customer.identifier;
                    data.ownerGender = customerDetails.customer.gender;
                    data.ownerMaritalStatus = customerDetails.customer.maritalStatus;


                    const bDate = new Date(customerDetails.customer.dateOfBirth);
                    data.ownerDateOfBirth = bDate;

                    const iDate = new Date(customerDetails.customer.identityIssueDate);
                    data.ownerIdentityIssueDate = iDate;

                    var msg = "ת.ז. קיימת פרטי לקוח עודכנו";
                    var postalCode = data.ownerAddress ? data.ownerAddress.postalCode : "";
                    if (customerDetails.customer.customerAddresses && customerDetails.customer.customerAddresses.length > 0 && postalCode != customerDetails.customer.customerAddresses[0].postalCode)
                        msg += '\nשים לב, מיקוד השתנה!';
                    data.ownerGender = customerDetails.customer.gender;

                    data.ownerContactDetails = customerDetails.customer.customerContactDetails[0];
                    data.ownerAddress = customerDetails.customer.customerAddresses[0];



                    await this.setState({
                        showModel: true,
                        message: msg,
                        statusMessege: "שגיאה",
                        agreementAlert: true,
                        productionData: data,
                        customerId: customerDetails.customer.id
                    });

                    await this.setState({ productionData: data });



                    return false;
                }
            }
        }
        return true;
    }

    setOwnerCustomerData = async (name: string, value: any) => {
        let newValue = '';
        const data = this.state.productionData;
        // let number = Number(value);
        const productionDataTemp = this.state.productionData ? this.state.productionData : null;
        if (productionDataTemp) {
            if (name === 'ownerIdentifier' && await this.checkIfIdentifierExist(value) === false) {
                
                await this.checkIfIsClient();
                // let errorData = this.state.validationErrors;
                // errorData['identifier'] = 'תעודת זהות קיימת במערכת';
                // this.setState({ validationErrors: errorData });
            }

            if (name === 'ownerIdentityType' &&
                !(productionDataTemp && ((productionDataTemp.ownerIdentityType === 1 && Number(value) === 2) ||
                    (productionDataTemp.ownerIdentityType === 2 && Number(value) === 1)))
            ) {
                this.setAlertMessege('לשינוי סוג זיהוי ', 'lead');
                return;
            }

            if (name == "ownerMaritalStatus") {
                this.setState({ showModel: true, message: "שים לב שהינך משנה מצב משפחתי של בעל הרכב", statusMessege: 'שגיאה', agreementAlert: true });
            }

            if (name == "ownerGender") {
                this.setState({ showModel: true, message: "שים לב שהינך משנה מגדר בעל הרכב", statusMessege: 'שגיאה', agreementAlert: true });
            }

            // if (name == 'dateOfBirth') {
            //     //
            //     newValue = moment(value).format('YYYY-MM-DDTHH-MM-SS')
            //     this.setState({ showModel: true, message: "שים לב שהינך משנה תאריך לידה", statusMessege: 'שגיאה', agreementAlert: true });
            // }

            (productionDataTemp as any)[name] = name === 'ownerIdentityType' ? Number(value) : value;
            //(data as any).ownerCustomer = ownerCustomerTemp;
            this.setState({ productionData: data });
        }

    }

    onBlurOwnerCustomerData = async (name: string, value: any) => {
        console.log('onBlurOwnerCustomerData', name, value);
        let newValue = value.toString();
        if(newValue && newValue.length > 0){
            let validateerrors = this.state.validationErrors;
            if(name === 'houseNumber' || name === 'mailbox'){
                delete validateerrors['houseNumber'];
                delete validateerrors['mailbox'];
            } else if(validateerrors[name]){
                delete validateerrors[name];
            }
            if(name === 'street'){
                delete validateerrors['mailbox'];
            }

            this.setState({ validationErrors: validateerrors });
        }
    }

    setStateData = (name: string, value: any) => {
        const data = this.state.productionData;
        if (data) {
            if (name === "authorizedToDrive") {
                this.setAlertMessege('לשינוי רשאים לנהוג ', 'simulator');
                return;
            }
            let bankCodeAndAddress = "";
            if (name === "involvedBankBranch") {
                const bank = this.state.allBanks.find(bank => bank.BankName === data.involvedBank);
                if (bank) {
                    const branch = bank.branchCode.find((branch: any) => branch.Branch_Code == value);
                    if (branch) {
                        bankCodeAndAddress = branch.Branch_Code + ", " + branch.Branch_Address;
                    }
                }
            }
            (data as any)[name] = bankCodeAndAddress.length > 0 ? bankCodeAndAddress : value;
            this.setState({ productionData: data });
        }

    }

    setComment = (name: string, event: any) => {
        const data = this.state.productionData;
        if (data != null) {
            if ((data as any).comment == null) {
                data.comment = event.currentTarget.value;

            } else {
                (data as any).comment = event.currentTarget.value;
            }
            this.setState({ productionData: data });
        }
    }

    setCheckboxStateData = (name: string, event: any) => {
        // console.log('event.currentTarget.checked', event.currentTarget.checked)

        const data = this.state.productionData;
        if (event.currentTarget.checked === true) {
            data.driverMainIdentifier = this.state.productionData.ownerIdentifier;
            data.driverMainFirstName= this.state.productionData.ownerFirstName;
            data.driverMainLastName = this.state.productionData.ownerLastName;
            data.driverMainBirthDate = this.state.productionData.ownerDateOfBirth;
            // data.driverMainSeniorityDate = this.state.productionData.ownerIdentityIssueDate;
        }
        if (event.currentTarget.checked === false && this.state.productionData.ownerIdentifier == data.driverMainIdentifier) {
            data.driverMainIdentifier = '';
            data.driverMainFirstName = '';
            data.driverMainLastName = '';
            data.driverMainBirthDate = null;
            // data.driverMainSeniorityDate = null;
        }
        (data as any)[name] = event.currentTarget.checked;
        this.setState({ productionData: data });
    }


    setCheckBoxYoungDriver = (name: string, event: any) => {
        // console.log('event.currentTarget.checked', event.currentTarget.checked)
        const data = this.state.productionData;
        if (event.currentTarget.checked === true) {
            data.driverYoungIdentifier = this.state.productionData.ownerIdentifier;
            data.driverYoungFirstName = this.state.productionData.ownerFirstName;
            data.driverYoungLastName = this.state.productionData.ownerLastName;
            data.driverYoungBirthDate = this.state.productionData.ownerDateOfBirth;
            // data.driverYoungSeniorityDate = this.state.productionData.ownerIdentityIssueDate;
        }
        if (event.currentTarget.checked === false && this.state.productionData.ownerIdentifier == data.driverYoungIdentifier) {
            data.driverYoungIdentifier = '';
            data.driverYoungFirstName = '';
            data.driverYoungLastName = '';
            data.driverYoungBirthDate = null;
            // data.driverYoungSeniorityDate = null;
        }
        (data as any)[name] = event.currentTarget.checked;
        this.setState({ productionData: data });
    }

    setCheckboxContactCalling = (event: any) => {
        const data = this.state.productionData;
        if (event.currentTarget.checked === true) {
            data.contactPersonName = this.state.productionData.ownerFirstName + " " + this.state.productionData.ownerLastName;
            data.contactPersonPhone = this.state.productionData.ownerContactDetails ? this.state.productionData.ownerContactDetails.number : "1";
        } else if (event.currentTarget.checked === false) {
            data.contactPersonName = "";
            data.contactPersonPhone = "";
        }
        this.setState({ productionData: data, callingContactChecked: event.currentTarget.checked });
    }

    setAdressData = async (name: string, value: any) => {
        const addresses = this.state.productionData.ownerAddress;
        addresses[0][name] = value;
        this.setOwnerCustomerData("customerAddresses", addresses);

        // this.setState({Streets: street})
    }

    loadStreets = async (search: any) => {
        var city = "";
        if (typeof search === 'string')
            city = search;
        else
            city = search.currentTarget.innerHTML;
        this.setAdressData("city", city);
        // this.setLeadStateData("city", city);
        //var streets = await new ManulApiModel().GetStreetsByCity(city)
        //this.setStateData("Streets", streets);
    }

    setAlertMessege = (message: string, navigate: string) => {
        this.setState({ showModel: true, message: message, statusMessege: 'התראה', navigatePath: navigate });
    }

    handleClick = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    }

    setStreetsState = (value: any) => {
        this.setState({ streetsListData: value })
    }

    setFilesData = (type: number, fileName: string, value: any) => {
        const data = this.state.productionData;
        if (data.fileAttachments && data.fileAttachments.length > 0) {
            let isFound = false;
            // find the file in fileAttachments array and update the value
            data.fileAttachments.map((file: any) => {
                if (file.fileName === fileName) {
                    file.url = value;
                    isFound = true;
                }
            });
            if (!isFound) {
                data.fileAttachments.push({ 'type': type, 'fileName': fileName, 'url': value });
            }
        } else if (data.fileAttachments == null || data.fileAttachments.length == 0) {
            data.fileAttachments = [{ 'type': type, 'fileName': fileName, 'url': value }];
        }

        this.setState({ productionData: data });
    }

    deleteFile = async (type: number) => {

        const data = this.state.productionData;
        console.log('first', data.elementaryPolicyDocuments.find((file: any) => file.elementaryPolicyDocumentType == type))
        const file = data.elementaryPolicyDocuments.find((file: any) => file.elementaryPolicyDocumentType == type);
        if (file) {
            data.elementaryPolicyDocuments = data.elementaryPolicyDocuments.filter((file: any) => file.elementaryPolicyDocumentType != type);
            console.log('data.fileAttachments', data.elementaryPolicyDocuments)
            this.setState({ productionData: data });
            let res = await this.offerProductionModel.deleteFile(file.id);
            if (res.label == "המסמך נמחק בהצלחה!") {
                this.setState({ showSavingModel: false, showModel: true, message: "הקובץ נמחק בהצלחה", statusMessege: 'שרת' });
            } else {
                this.setState({ showSavingModel: false, showModel: true, message: "הקובץ לא נמחק", statusMessege: 'שגיאה' })
            }
        }
        const dataFile = data.fileAttachments.find((file: any) => file.type == type);
        if (dataFile) {
            data.fileAttachments = data.fileAttachments.filter((file: any) => file.type != type);
            this.setState({ productionData: data });
        }
    }

    isValideLicenseNumber = async (licenseNumber: string) => {
        const data = await new SimulatorModel().getVehicleDetailsByLicenseNumber(licenseNumber);
        console.log('getVehicleDetails data', data);
        if (data && data.LeviItzhak) {
            if (!data.LeviItzhak.vehicleModel && data.LeviItzhak.error.code > 0) {
                console.log("מספר רכב לא קיים במשרד הרישוי");
                return false;
            }
            if (data.LeviItzhak.vehicleSubModel) {
                console.log('modelCode', data.LeviItzhak.vehicleSubModel.code, "===", this.state.productionData.vehicle.modelCode)
                if (data.LeviItzhak.vehicleSubModel.code == this.state.productionData.vehicle.modelCode) {
                    console.log("same model code");
                    return true;
                }
            }
        } else {
            console.log("no data from getVehicleDetailsByLicenseNumber");

            return false;
        }
    }

    validationTab1 = () => {
        console.log('validationTab1-validationErrors', this.state.validationErrors)
        let isValid = true;
        let validationErrors: { [key: string]: string } = {...this.state.validationErrors}
        console.log('validationErrors', validationErrors)

        // Validating all necessary fields
        const adressDetails = ['city', 'street', 'houseNumber', 'apartmentNumber', 'mailbox', 'postalCode'];
        const contactDetails = ['number', 'emailAddress'];

        validationPersonalDetailsDriver.forEach((field) => {

            var add = this.state.productionData.ownerAddress;
            const value = adressDetails.includes(field) ? (this.state.productionData as any)['ownerAddress'][field]
                : contactDetails.includes(field) ? (this.state.productionData as any)['ownerContactDetails'][field]
                    : (this.state.productionData as any)[field];

            const errorMessage = this.validateInput(field, field === 'number' && value ? value.trim() : value);
            // debugger
            if (errorMessage) {
                if (errorMessage !== 'שדה חובה') {
                    isValid = false;
                }
                validationErrors[field] = errorMessage;
            }
        });

        if (!isValid) {
            console.log('isValid', isValid)
            this.setState({ validationErrors });
            return isValid; // Exit if there are validation errors
        }

        console.log('validationErrors', validationErrors)

        const errorMesege = Object.fromEntries(
            Object.entries(validationErrors).filter(([key, value]) => value === 'שדה חובה')
        );

        this.setState({ validationErrors: errorMesege });

        return isValid;
    }

    emptyDate = (date: string) => {
        if (!date)
            return true;
        const _date = new Date(date);
        if (_date.getFullYear() === 1 && _date.getMonth() === 0 && _date.getDate() === 1)
            return true;
        return false;
    }


    validationTab2 = async () => {
        //
        let isValid = true;
        let validationErrors: { [key: string]: string } = {};

        // Validating all necessary fields
        const vehicleList = ['licenseNumber', 'modelCode', 'carYear'];
        const adressDetails = ['city', 'street', 'houseNumber', 'apartmentNumber', 'mailbox', 'postalCode'];
        const contactDetails = ['number', 'emailAddress'];

        validationPersonalDetailsDriver.forEach((field) => {
            const value = adressDetails.includes(field) ? (this.state.productionData as any)['ownerAddress'][field]
                : contactDetails.includes(field) ? (this.state.productionData as any)['ownerContactDetails'][field]
                    : (this.state.productionData as any)[field];

            const errorMessage = this.validateInput(field, field === 'number' && value ? value.trim() : value);
            // debugger
            if (errorMessage) {
                if (errorMessage !== 'שדה חובה') {
                    isValid = false;
                }
                validationErrors[field] = errorMessage;
            }
        });


        const validationfieldArray = this.getValidationsFields();
        // console.log('validationfieldArray :>> ', validationfieldArray);
        validationfieldArray != undefined && validationfieldArray.forEach((field) => {
            console.log('field', field);
            let value = '';

            if (field === 'identifierMainDriver') {
                value = this.state.productionData.driverMainIdentifier;
            } else if (field === 'firstNameMainDriver') {
                value = this.state.productionData.driverMainFirstName;
            } else if (field === 'lastNameMainDriver') {
                value = this.state.productionData.driverMainLastName;
            } else if (field === 'driverMainSeniorityDate') {
                value = this.state.productionData.driverMainSeniorityDate;
            } else if (field === 'driverMainBirthDate') {
                value = this.state.productionData.driverMainBirthDate;
                console.log('field', field, field === 'driverMainBirthDate');
                console.log('field-value', value)
            } else if (field === 'driverYoungSeniorityDate') {
                value = this.state.productionData.driverYoungSeniorityDate;
            } else if (field === 'driverYoungBirthDate') {
                value = this.state.productionData.driverYoungBirthDate;
            } else if (field === 'identifierYoung') {
                value = this.state.productionData.driverYoungIdentifier;
            } else if (field === 'firstNameYoung') {
                value = this.state.productionData.driverYoungFirstName;
            } else if (field === 'lastNameYoung') {
                value = this.state.productionData.driverYoungLastName;
            } else if (field === 'vehicleModel') {
                value = this.state.productionData.vehicle.vehicleSubModel && this.state.productionData.vehicle.vehicleSubModel.name;
            } else if (vehicleList.includes(field)) {
                value = (this.state.productionData.vehicle as any)[field]
            }
            console.log('value', value)
            const errorMessage = this.validateInput(field, value);
            
            if (errorMessage) {
                if (errorMessage !== 'שדה חובה' && errorMessage !== 'תז קיימת בבעל הרכב') {
                    isValid = false;
                }
                validationErrors[field] = errorMessage;
            }
        });

        if (this.state.SelectedTab === "tab-content-2") {
            let licenceCarNumver = await this.isValideLicenseNumber(this.state.productionData.vehicle.licenseNumber);
            if (!licenceCarNumver) {
                isValid = false;
                validationErrors['licenseNumber'] = 'מספר רכב לא תקין';
            }
        }
        // console.log('validationTab2-validationErrors', validationErrors)

        if (!isValid) {
            console.log('isValid', isValid)
            this.setState({ validationErrors });
            return isValid; // Exit if there are validation errors
        }

        const errorMesege = await Object.fromEntries(
            Object.entries(validationErrors).filter(([key, value]) => value === 'שדה חובה' || value === 'תז קיימת בבעל הרכב')
        );

        // console.log('validationTab2', errorMesege);
        // make the setState of the validation errors finish before the return

        this.setState({ validationErrors: { ...errorMesege } });

        return isValid;

    }


    validationTab5 = async () => {
        //
        let isValid = true;
        var pp = this.state.productionData;
        let errorMessege = this.state.validationErrors

        if (pp.comprehensivePaymentDetails && pp.comprehensivePaymentDetails[0].length > 4) {
            if (pp.comprehensivePaymentDetails[1].length == 0) {
                errorMessege['ccExpireDate'] = 'שדה חובה';
                isValid = false;
            } else if (pp.comprehensivePaymentDetails[1].length < 4 || pp.comprehensivePaymentDetails[1].length > 5) {
                errorMessege['ccExpireDate'] = 'תאריך פג תוקף לא תקין';
                isValid = false;
            }
            if (pp.comprehensivePaymentDetails[2].length == 0) {
                errorMessege['cvv'] = 'שדה חובה';
                isValid = false;
            } else if (pp.comprehensivePaymentDetails[2].length < 3 || pp.comprehensivePaymentDetails[2].length > 4) {
                errorMessege['cvv'] = 'מספר CVV לא תקין';
                isValid = false;
            }
            if (pp.comprehensivePaymentDetails[3].length == 0) {
                errorMessege['ccHolderId'] = 'שדה חובה';
                isValid = false;
            }
            if (pp.comprehensivePaymentDetails[4].length == 0) {
                errorMessege['ccHolder'] = 'שדה חובה';
                isValid = false;
            }
        }
        if (pp.compulsoryPaymentDetails && pp.compulsoryPaymentDetails[0].length > 4) {
            if (pp.compulsoryPaymentDetails[1].length == 0) {
                errorMessege['compulsoryCcExpireDate'] = 'שדה חובה';
                isValid = false;
            } else if (pp.compulsoryPaymentDetails[1].length < 4 || pp.compulsoryPaymentDetails[1].length > 5) {
                errorMessege['compulsoryCcExpireDate'] = 'תאריך פג תוקף לא תקין';
                isValid = false;
            }
            if (pp.compulsoryPaymentDetails[2].length == 0) {
                errorMessege['compulsoryCvv'] = 'שדה חובה';
                isValid = false;
            } else if (pp.compulsoryPaymentDetails[2].length < 3 || pp.compulsoryPaymentDetails[2].length > 4) {
                errorMessege['compulsoryCvv'] = 'מספר CVV לא תקין';
                isValid = false;
            }
            if (pp.compulsoryPaymentDetails[3].length == 0) {
                errorMessege['compulsoryCcHolderId'] = 'שדה חובה';
                isValid = false;
            }
            if (pp.compulsoryPaymentDetails[4].length == 0) {
                errorMessege['compulsoryCcHolder'] = 'שדה חובה';
                isValid = false;
            }
        }
        if (pp.ridersPaymentDetails && pp.ridersPaymentDetails[0].length > 4) {
            if (pp.ridersPaymentDetails[1].length == 0) {
                errorMessege['ridersCcExpireDate'] = 'שדה חובה';
                isValid = false;
            } else if (pp.ridersPaymentDetails[1].length < 4 || pp.ridersPaymentDetails[1].length > 5) {
                errorMessege['ridersCcExpireDate'] = 'תאריך פג תוקף לא תקין';
                isValid = false;
            }
            if (pp.ridersPaymentDetails[2].length == 0) {
                errorMessege['ridersCvv'] = 'שדה חובה';
                isValid = false;
            } else if (pp.ridersPaymentDetails[2].length < 3 || pp.ridersPaymentDetails[2].length > 4) {
                errorMessege['ridersCvv'] = 'מספר CVV לא תקין';
                isValid = false;
            }
            if (pp.ridersPaymentDetails[3].length == 0) {
                errorMessege['ridersCcHolderId'] = 'שדה חובה';
                isValid = false;
            }
            if (pp.ridersPaymentDetails[4].length == 0) {
                errorMessege['ridersCcHolder'] = 'שדה חובה';
                isValid = false;
            }
        }

        if (pp.contactPersonName == null || pp.contactPersonName == '') {
            console.log('pp.contactPersonName', pp.contactPersonName)
            errorMessege['contactPersonName'] = 'שדה חובה';
            isValid = false;
        }
        if (pp.contactPersonPhone == null || pp.contactPersonPhone == '') {
            console.log('pp.contactPersonPhone', pp.contactPersonPhone)
            errorMessege['contactPersonPhone'] = 'שדה חובה';
            isValid = false;
        }
        if (!isValid) {
            this.setState({ validationErrors: errorMessege });
            return isValid; // Exit if there are validation errors
        }
        return isValid;
    }

    onChangeFromErrorToValid = (name: string) => {
        let validationErrors = this.state.validationErrors;
        if (validationErrors[name]) {
            delete validationErrors[name];
            this.setState({ validationErrors: validationErrors });
        }
    }

    dataIsValid = async () => {
        var tab = this.state.SelectedTab;
        if (tab === "tab-content-1") {
            if (await this.validationTab1()) {
                return true;
            }
        }

        if (tab === "tab-content-2") {
            if (await this.validationTab2()) {
                // console.log('validationErrors', this.state.validationErrors);
                return true;
            }
        }
        if (tab === "tab-content-3") {
            if (await this.validationTab2()) {
                return true;
            }
        }
        if (tab === "tab-content-4") {
            if (await this.validationTab2()) {
                return true;
            }
        }
        if (tab === "tab-content-5") {

            var tab2Valid = await this.validationTab2();
            var tab5Valid = await this.validationTab5();
            if (tab2Valid && tab5Valid) {
                return true;
            }

        }
        return false;
    }

    nextTab = async (sign: any) => {
        //tab-content-1
        // this.saveProduction();
        //
        const dataValid = await this.dataIsValid();
        var tab = this.state.SelectedTab;
        var tabNumber = parseInt(tab.split("-")[2]);
        if (sign == "-" || sign == "+") {
            if (sign == "-") {
                tabNumber--;
            } else if (sign == "+") {

                // need to make walidation of variable in the current tub and if data is ok make tabNumber++
                if (dataValid) {
                    tabNumber++;
                } else {
                    return;
                }
            }
            this.setState({ SelectedTab: "tab-content-" + tabNumber });
        }
        else {
            this.setState({ SelectedTab: sign });
        }
    }

    validationOnAdress = (name: string, value: any) => {

        if (this.state.productionData && this.state.productionData.ownerAddress) {
            let street = this.state.productionData.ownerAddress.street;
            let house = this.state.productionData.ownerAddress.houseNumber;
            let mailbox = this.state.productionData.ownerAddress.mailbox;
            if ((name === 'street' || name === 'houseNumber') && this.state.productionData.ownerAddress.mailbox && this.state.productionData.ownerAddress.mailbox !== '') {
                return true;
            } else if ((name === 'street' || name === 'houseNumber') && (this.state.productionData.ownerAddress.mailbox == null || this.state.productionData.ownerAddress.mailbox == '')) {
                return false;
            } else if (name === 'mailbox' && this.state.productionData.ownerAddress.street && this.state.productionData.ownerAddress.street !== ''
                && this.state.productionData.ownerAddress.houseNumber && this.state.productionData.ownerAddress.houseNumber > 0) {
                return true;
            } else if (name === 'mailbox' && (this.state.productionData.ownerAddress.street == null || this.state.productionData.ownerAddress.street == '')
                && (!this.state.productionData.ownerAddress.houseNumber || this.state.productionData.ownerAddress.houseNumber == 0)) {
                return false;
            }
        }
        return false;
    }

    validateInput = (name: string, value: any): string => {
        let fieldNotMust = ['emailAddress', 'apartmentNumber', 'identifierYoung', 'firstNameYoung', 'lastNameYoung']
        //authorizedToDrive 
        debugger
        let validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        let errorMessage = '';
        if (name === 'fullName' && this.state.productionData && (this.state.productionData.ownerIdentityType == 0 || this.state.productionData.ownerIdentityType == 1 || this.state.productionData.ownerIdentityType == 2)) {
            return '';
        }
        if (name === 'driverMainBirthDate' || name === 'driverYoungBirthDate') {
            if (value && value === '0001-01-01T00:00:00') {
                return 'שדה חובה';
            }
        }

        if (!value || value.toString().trim() === '') {
            if (!fieldNotMust.includes(name) || this.state.productionData.authorizedToDrive != 2) {
                if (name !== 'emailAddress' && name !== 'apartmentNumber' && name !== 'fullName' && !this.validationOnAdress(name, value)) {
                    errorMessage = 'שדה חובה';
                }
            }
        } else if (name === 'licenseNumber' && isNaN(value)) {
            errorMessage = 'מספר רכב לא תקין';
        } else if (name === 'ownerDateOfBirth' && this.state.productionData && (!this.state.productionData.ownerIdentityType || this.state.productionData.ownerIdentityType == IdentityType._1) && this.emptyDate(value)) {
            errorMessage = 'שדה חובה';
        } else if (name === 'emailAddress' && !validRegex.test(value) && value !== null) {
            errorMessage = 'כתובת מייל לא תקינה';
        } else if (name === 'number' && (isNaN(value) || value.length > 10 || value.length < 9)) {
            errorMessage = 'מספר טלפון לא תקין';
        } else if (name === 'postalCode' && isNaN(value)) {
            errorMessage = 'מיקוד לא תקין';
        } else if (name === 'houseNumber' && isNaN(value)) {
            errorMessage = 'מספר בית לא תקין';
        } else if (name === 'apartmentNumber' && isNaN(value)) {
            errorMessage = 'מספר דירה לא תקין';
        } else if (name === 'mailbox' && isNaN(value)) {
            errorMessage = 'ת.ד לא מספר תקין';
        } else if ( this.state.productionData && this.state.productionData.ownerIdentityType == IdentityType._1 && (name === 'ownerIdentifier' || name === 'identifierMainDriver' || name === 'identifierYoung')
            && value.length > 0 && (isNaN(value) || !this.validateIdentifier(name, value.trim()))) {
            errorMessage = 'תעודת זהות לא תקין';
        }

        // if identifier is the same as the owner
        // else if (name === 'identifierYoung' && value === this.state.productionData.ownerCustomer.identifier) {
        //     errorMessage = 'תז קיימת בבעל הרכב';
        // } 
        else if (name === 'identifierMainDriver' && value === this.state.productionData.ownerIdentifier && !this.state.productionData.ownerIsMainDriver) {
            errorMessage = 'תז קיימת בבעל הרכב';
        }

        // if young driver is identifeir is the same as the main driver
        else if (this.state.productionData.authorizedToDrive == 1 /*two driverrs*/ && name === 'identifierMainDriver' && value === this.state.productionData.driverYoungIdentifier) {
            errorMessage = 'תז קיימת בנהג צעיר';
        } else if (this.state.productionData.authorizedToDrive == 1 /*two driverrs*/ && name === 'identifierYoung' && value === this.state.productionData.driverMainIdentifier) {
            errorMessage = 'תז קיימת בנהג עיקרי';
        }

        else if (name === 'identifierMainDriver' && this.state.productionData.ownerIsMainDriver
            && (value !== this.state.productionData.ownerIdentifier && this.state.productionData.ownerIdentifier !== '')) {
            errorMessage = 'תז לא תואמת לבעל הרכב';
        } else if ((name === 'ownerFirstName' || name === 'firstNameYoung' || name === 'firstNameMainDriver') && !/^[a-zA-Zא-ת\s]*$/.test(value)) {
            errorMessage = 'שם פרטי חייב להיות אותיות בלבד';
        } else if ((name === 'ownerLastName' || name === 'lastNameYoung' || name === 'lastNameMainDriver') && !/^[a-zA-Zא-ת\s]*$/.test(value)) {
            errorMessage = 'שם משפחה חייב להיות אותיות בלבד';
        } else if (name === 'fullName' && !/^[a-zA-Zא-ת\s]*$/.test(value) && this.state.productionData.ownerIdentityType == 3 || this.state.productionData.ownerIdentityType == 4) {
            errorMessage = 'שם חברה חייב להיות אותיות בלבד';
        } else if (name === 'modelCode' && isNaN(value)) {
            errorMessage = 'קוד דגם לא מספר תקין';
        } else if (name === 'carYear' && isNaN(value)) {
            errorMessage = 'שנת ייצור לא תקין';
        }

        return errorMessage;
    };

    getValidationsFields = () => {
        if (this.state.productionData.authorizedToDrive == 0) {
            return ['firstNameMainDriver', 'lastNameMainDriver', 'identifierMainDriver', 'driverMainSeniorityDate', 'driverMainBirthDate', 'licenseNumber', 'modelCode', 'vehicleModel', 'carYear'];
        } else if (this.state.productionData.authorizedToDrive == 1) {
            return ['firstNameMainDriver', 'lastNameMainDriver', 'identifierMainDriver', 'driverMainSeniorityDate', 'driverMainBirthDate', 'driverYoungSeniorityDate', 'driverYoungBirthDate', 'identifierYoung', 'firstNameYoung', 'lastNameYoung', 'licenseNumber', 'modelCode', 'vehicleModel', 'carYear'];
        } else if (this.state.productionData.authorizedToDrive == 2) {
            return ['identifierYoung', 'firstNameYoung', 'lastNameYoung', 'driverYoungSeniorityDate', 'driverYoungBirthDate', 'licenseNumber', 'modelCode', 'vehicleModel', 'carYear'];
        }
    }

    getSigningUserName = (id: string) => {
        if (this.state.usersSignatures && this.state.usersSignatures.length > 0) {
            let user: any = this.state.usersSignatures.find((x: any) => x.id == id);
            if (user) {
                return user.fullName;
            }
        }
        return "";
    }

    saveAsADraft = async (productionMode: number) => {
        try {
            this.setState({ saveLoading: true })

            let messageSuccess = productionMode == 1 ? `המידע נשמר בהצלחה, טיוטת פוליסה נשלחה לחתם ${this.getSigningUserName(this.state.productionData.underwriterUserId)}` : 'המידע נשמר בהצלחה';
            const result = await this.offerProductionModel.saveDataProduction(this.state.productionData)
            if (result.status === 200) {
                this.setState({ saveLoading: false })
                this.setState({ showSavingModel: false, showModel: true, message: messageSuccess, statusMessege: 'שרת', log: result.messageData });

                setTimeout(() => {
                    this.closeProduction();
                }, 2000);
                this.setState({ saveProductionAndSuccess: true });

                if(productionMode == 1){
                    this.props.setReloadLeads(true);
                }
            } else {
                if(result.status === 400){
                    this.setState({ showSavingModel: false, showModel: true, message: 'שגיאה בשמירת הפוליסה', statusMessege: 'שגיאה', saveLoading: false, log: result.messageData });
                }
                this.setState({ showSavingModel: false, showModel: true, message: 'שגיאה בשמירת הפוליסה', statusMessege: 'שגיאה', saveLoading: false, log: result.messageData });
            }
        } catch (error) {
            this.setState({ showSavingModel: false, showModel: true, message: 'שגיאה בשמירת הפוליסה', statusMessege: 'שגיאה', saveLoading: false })
        }
    }

    saveProduction = async () => {
        this.setState({ hasClickToSaveAndProduction: true })
        const dataValid = await this.dataIsValid();
        setTimeout(() => {

            if (Object.keys(this.state.validationErrors).length > 0 || !dataValid) {
                this.setState({ showSavingModel: true })
                this.setState({ hasClickToSaveAndProduction: false })
            } else {
                this.saveAsADraft(0)
            }
        }, 500);
    }

    makeProduction = async () => {
        this.setState({ hasClickToSaveAndProduction: true, agreementAlert: false })
        const dataValid = await this.dataIsValid();
        if (!dataValid) {
            this.setState({ showModel: true, message: 'שגיאות במילוי הטופס', statusMessege: 'שגיאה' })
            this.setState({ hasClickToSaveAndProduction: false })
            return;
        }
        var dataValide = true;

        if (Object.keys(this.state.validationErrors).length > 0) {
            this.setState({ showModel: true, message: 'קיימים שדות חובה ריקים אנא מלא אותם לפני חיתום הפקה', statusMessege: 'שגיאה' })
            this.setState({ hasClickToSaveAndProduction: false })
            return;
        }

        // underwriterUserId
        if (this.state.productionData.underwriterUserId == null || this.state.productionData.underwriterUserId === "") {
            let errorMessege = this.state.validationErrors
            errorMessege['underwriterUserId'] = 'לא נבחר חותם';
            this.setState({ validationErrors: errorMessege })
            dataValide = false;
        }

        // check if time in datetime equele to 00:00
        if (this.state.productionData.endDate != null && this.state.productionData.endDate !== "") {
            const endDate = new Date(this.state.productionData.endDate);
            if (endDate.getHours() === 0 && endDate.getMinutes() === 0) {
                let errorMessege = this.state.validationErrors
                errorMessege['endTime'] = 'יש לבחור שעת יעד ההפקה';
                this.setState({ validationErrors: errorMessege })
                dataValide = false;
            }
        }


        if (this.state.productionData.checkbox1 == false || this.state.productionData.checkbox2 == false || this.state.productionData.checkbox3 == false) {
            this.setState({ agreementAlert: true });

            dataValide = false;
        } else {
            this.setState({ agreementAlert: false });
        }

        if (!dataValide) {
            this.setState({ hasClickToSaveAndProduction: false })
            this.setState({ showModel: true, message: 'יש לגלול מטה לאישור הערות/בחירת חתם/שעת יעד הפקה', statusMessege: 'שגיאה' })
            return;
        }

        let productionData = this.state.productionData;
        productionData.productionMode = 1;
        this.setState({ productionData: productionData });

        this.saveAsADraft(1);

    }

    renderValidationError = (fieldName: string) => {
        var ff = this.state.validationErrors;
        if (this.state.validationErrors[fieldName]) {
            return this.state.validationErrors[fieldName];
        }
        return null;


        // return this.state.validationErrors[fieldName] ? (
        //     <div className="validation-error">{this.state.validationErrors[fieldName]}</div>
        // ) : null;
    };

    onUpdateComprehensivePaymentDetails = (fieldName: string[], numberOfPayment: number) => {
        let productionData = this.state.productionData;
        productionData.comprehensivePaymentDetails = fieldName;
        productionData.comprehensiveInsuranceNumberOfPayments = numberOfPayment;
        this.setState({ productionData: productionData });

    };

    onUpdateCompulsoryPaymentDetails = (fieldName: string[], numberOfPayment: number) => {
        let productionData = this.state.productionData;
        productionData.compulsoryPaymentDetails = fieldName;
        productionData.compulsoryInsuranceNumberOfPayments = numberOfPayment;
        this.setState({ productionData: productionData });

    };

    onUpdateRidersPaymentDetails = (fieldName: string[], numberOfPayment: number) => {

        let productionData = this.state.productionData;
        productionData.ridersPaymentDetails = fieldName;
        productionData.riderNumberOfPayments = numberOfPayment;
        this.setState({ productionData: productionData });

    };



    // renderValidationError = (fieldName: string, val: string = '' ): string => {
    //     return this.state.validationErrors[fieldName] ?
    //         this.state.validationErrors[fieldName]
    //         : "";
    // };


    handleMouseDown = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
        this.setState({ isDragging: true, offset: { x: e.clientX - this.state.position.x, y: e.clientY - this.state.position.y } });
    };

    handleMouseMove = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
        if (this.state.isDragging) {
            this.setState({ position: { x: e.clientX - this.state.offset.x, y: e.clientY - this.state.offset.y } });
        }
    };

    handleMouseUp = (): void => {
        this.setState({ isDragging: false });
    };

    getOfferProduction = () => {
        return this.state.productionData;
    }


    setAgreements = (name: string) => {
        const data = this.state.productionData;
        (data as any)[name] = !(data as any)[name];
        this.setState({ productionData: data });
    }

    setUserSignature = (value: string) => {
        const data = this.state.productionData;
        (data as any)['underwriterUserId'] = value
        this.setState({ productionData: data });
    }

    setEndTime = (value: string) => {
        const data = this.state.productionData;
        const endDate = data.endDate;

        // Parse picked time
        const [h, m] = value.split(":").map(Number);

        // Clone date and set new time
        const updated = new Date(endDate);
        updated.setHours(h, m, 0, 0);

        // Adjust for timezone so it's local ISO
        const localISO = new Date(
            updated.getTime() - updated.getTimezoneOffset() * 60000
        ).toISOString().slice(0, 19); // cut off ms and 'Z'

        data.endDate = localISO;
        this.setState({ productionData: data });
    }

    isAdmin = () => {
        const user = localStorage.getItem('loggedUser')
        if (user) {
            const userData = JSON.parse(user);
            if (userData.role == 0) {
                console.log('isAdmin-userData', userData)
                return true;
            }
        }
        return false;
    }

    setIsClientDetailsEditTrue = () => {
        if(this.state.clientData){
            this.setState({isClient:true});
        }
    }


    render() {

        return (
            <>
                {this.state.showModel && (
                    <OfferProductionResponseModel
                        show={this.state.showModel}
                        log={this.state.log}
                        showLog={this.props.showLog}
                        onClose={() => this.setState({ showModel: false })}
                        navigateToSmilator={this.closeProduction}
                        message={this.state.message}
                        statusMessege={this.state.statusMessege}
                        navigatePath={this.state.navigatePath}
                        leadId={this.state.productionData.offer.leadId}
                        goToSimulator={this.props.onGoToSimulatorClick}
                        onEdit={this.props.onEdit}
                        productionData={this.state.productionData}
                    />
                )}

                {this.state.showSavingModel && (
                    <SavingPopUp
                        show={this.state.showSavingModel}
                        onClose={() => this.setState({ showSavingModel: false })}
                        saveAsADraft={this.saveAsADraft}
                    />
                )
                }

                {this.state.saveProductionAndSuccess && (
                    <OfferProductionSuccessNavigateToLead
                        show={this.state.saveProductionAndSuccess}
                        onClose={() => this.setState({ saveProductionAndSuccess: false })}
                        leadId={this.state.productionData.offer.lead.id}
                        lead={this.state.productionData.offer.lead}
                    />
                )
                }

                {
                    this.state.isClient && this.state.clientData && (
                        <UpdateClientDetails
                            clientData={this.state.clientData}
                            onClose={() => this.setState({ isClient: false })}
                            onSave= {(identifeir: string)=> this.loadOfferByIdAfterUpdateClientData(identifeir)}
                            />
                    )
                }



                {this.state.productionData ? (
                    <div className={this.state.productionData != null ? "popup-wrapper offerProduction" : "hide"}>


                        <div className="settings-window rtl"
                            style={{ position: 'relative', top: this.state.position.y, left: this.state.position.x }}

                        >
                            {(this.state.productionData.id && this.state.productionData.id != this.GUID_EMPTY) ||
                                moment(this.state.productionData.startDate).tz("Israel").format('YYYY-MM-DDTHH:mm:ss').split('T')[0] >= moment(new Date()).tz("Israel").format('YYYY-MM-DDTHH:mm:ss').split('T')[0] ? (
                                <>
                                    <div className="close-icon pointer" onClick={(e: any) => { this.closeProduction() }}></div>
                                    <div className="top-row"
                                        style={{ cursor: this.state.isDragging ? 'grabbing' : 'grab', }}
                                        onMouseDown={this.handleMouseDown}
                                        onMouseMove={this.handleMouseMove}
                                        onMouseUp={this.handleMouseUp}
                                        onMouseLeave={this.handleMouseUp} // Prevent dragging if the mouse leaves the modal
                                    >
                                        <div className="popup-title">
                                            {"בקשה להפקת פוליסת ביטוח רכב להצעה מספר - " + this.state.productionData.offer.offerIdentity}
                                        </div>
                                    </div>
                                    <div className="popup-content-row">
                                        <div className="title-row">
                                            {this.getInsuranceCompany()}
                                        </div>
                                        <div className="prices-row">
                                            <div className="price-item">
                                                <div className="price-value flex">
                                                    <div className="price">
                                                        {this.state.productionData.compulsoryInsurancePrice}
                                                    </div>
                                                    <div className="currency">
                                                        שח
                                                    </div>
                                                </div>
                                                <div className="description">
                                                    פרמיית חובה
                                                </div>
                                            </div>
                                            <div className="price-item">
                                                <div className="price-value flex">
                                                    <div className="price">
                                                        {this.state.productionData.comprehensiveInsurancePrice}
                                                    </div>
                                                    <div className="currency">
                                                        שח
                                                    </div>
                                                </div>
                                                <div className="description">
                                                    פרמיית קסקו
                                                </div>
                                            </div>
                                            <div className="price-item">
                                                <div className="price-value flex">
                                                    <div className="price">
                                                        {this.calcRiders()}
                                                    </div>
                                                    <div className="currency">
                                                        שח
                                                    </div>
                                                </div>
                                                <div className="description">
                                                    ריידרים
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                                            <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#052F5D' }}>
                                                תאריך התחלה: {datePresentation(this.state.productionData.startDate as Date)}
                                            </div>
                                            <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#052F5D' }}>
                                                תאריך סיום: {datePresentation(this.state.productionData.endDate as Date)}
                                            </div>
                                            <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#052F5D' }}>
                                                שם: {(this.state.productionData != null) ?
                                                    this.state.productionData.ownerFirstName + " " + this.state.productionData.ownerLastName : ""}
                                            </div>

                                        </div>

                                        

                                        <div className="tab-titles-row">
                                            <div onClick={(sign: any) => this.nextTab("tab-content-1")} className={this.state.SelectedTab == "tab-content-1" ? "tab-title tab-selected" : "tab-title"} data-tab="tab-content-1">
                                                בעל הרכב
                                            </div>
                                            <div onClick={(sign: any) => this.nextTab("tab-content-2")} className={this.state.SelectedTab == "tab-content-2" ? "tab-title tab-selected" : "tab-title"} data-tab="tab-content-2">
                                                הרכב והנהגים
                                            </div>
                                            <div onClick={(sign: any) => this.nextTab("tab-content-3")} className={this.state.SelectedTab == "tab-content-3" ? "tab-title tab-selected" : "tab-title"} data-tab="tab-content-3">
                                                פרטי הביטוח כיסויים והנחות
                                            </div>
                                            <div onClick={(sign: any) => this.nextTab("tab-content-4")} className={this.state.SelectedTab == "tab-content-4" ? "tab-title tab-selected" : "tab-title"} data-tab="tab-content-4">
                                                מסמכים נלווים
                                            </div>
                                            <div onClick={(sign: any) => this.nextTab("tab-content-5")} className={this.state.SelectedTab == "tab-content-5" ? "tab-title tab-selected" : "tab-title"} data-tab="tab-content-5">
                                                פרטי תשלום והפקה
                                            </div>
                                        </div>
                                        {this.state.loading ?
                                            <div className="tab-contents-row">
                                                <div className={this.state.SelectedTab == "tab-content-1" ? "tab-content tab-content-1 selected" : "tab-content tab-content-1"}>
                                                    <PersonalDetailsDriver
                                                        productionData={this.state.productionData}
                                                        customerId={this.state.customerId}
                                                        setProductionDataData={this.setOwnerCustomerData}
                                                        setStateData={this.setStateData}
                                                        citiesForSearch={this.state.CitiesForSearch}
                                                        loadCities={this.loadCities}
                                                        loadStreets={this.loadStreets}
                                                        geder={this.state.Geder}
                                                        identityTypes={this.state.IdentityTypes}
                                                        maritalStatus={this.state.MaritalStatus}
                                                        birthDateRef={this.birthDateRef}
                                                        identifierDateRef={this.identifierDateRef}
                                                        renderValidationError={this.renderValidationError}
                                                        citiesListData={this.state.citiesListData}
                                                        streetsListData={this.state.streetsListData}
                                                        setStreetsState={this.setStreetsState}
                                                        setAlertMessege={this.setAlertMessege}
                                                        onBlurOwnerCustomerData={this.onBlurOwnerCustomerData}
                                                        loadData={this.loadData}
                                                    />
                                                </div>

                                                <div className={this.state.SelectedTab == "tab-content-2" ? "tab-content tab-content-2 selected" : "tab-content tab-content-2"} >
                                                    <CarAndDriversDetails
                                                        productionData={this.state.productionData}
                                                        offer={this.state.offer}
                                                        setStateData={this.setStateData}
                                                        // setStateInputData={this.setStateInputData}
                                                        geder={this.state.Geder}
                                                        authorizedToDrive={this.state.AuthorizedToDrive}
                                                        vehicleOwnership={this.state.VehicleOwnership}
                                                        maritalStatus={this.state.MaritalStatus}
                                                        // calcAge={this.calcAge}
                                                        mainLicenseDateRef={this.mainLicenseDateRef}
                                                        youngLicenseDateRef={this.youngLicenseDateRef}
                                                        setCheckboxStateData={this.setCheckboxStateData}
                                                        setCheckboxStateDataYoung={this.setCheckBoxYoungDriver}
                                                        renderValidationError={this.renderValidationError}
                                                        setAlertMessege={this.setAlertMessege}
                                                        oldData={this.state.oldProductionData}

                                                    />
                                                </div>
                                                <div className={this.state.SelectedTab == "tab-content-3" ? "tab-content tab-content-3 selected" : "tab-content tab-content-3"} >
                                                    <InsuraceAndCoversDetails
                                                        productionData={this.state.productionData}
                                                        allBanks={this.state.allBanks}
                                                        offer={this.state.offer}
                                                        InsuranceTypes={this.state.InsuranceTypes}
                                                        PassedTypeOfInsurance={this.state.PassedTypeOfInsurance}
                                                        setStateData={this.setStateData}
                                                        // setStateInputData={this.setStateInputData}
                                                        setComment={this.setComment}
                                                        renderValidationError={this.renderValidationError}
                                                        setAlertMessege={this.setAlertMessege}
                                                    />
                                                </div>
                                                <div className={this.state.SelectedTab == "tab-content-4" ? "tab-content tab-content-4 selected" : "tab-content tab-content-4"} >
                                                    <AttachedDocuments
                                                        setStateFiles={this.setFilesData}
                                                        deleteFile={this.deleteFile}
                                                        elementaryPolicyDocuments={this.state.elementaryPolicyDocuments}
                                                    />
                                                </div>
                                                <div className={this.state.SelectedTab == "tab-content-5" ? "tab-content tab-content-5 selected" : "tab-content tab-content-5"} >
                                                    <PaymentDetailsOfProduction
                                                        productionData={this.state.productionData}
                                                        authorizedToDriveData={this.state.AuthorizedToDrive}
                                                        gender={this.state.Geder}
                                                        maritalStatus={this.state.MaritalStatus}
                                                        agreementAlert={this.state.agreementAlert}
                                                        setAgreements={this.setAgreements}
                                                        usersSignatures={this.state.usersSignatures}
                                                        setUserSignature={this.setUserSignature}
                                                        setEndTime={this.setEndTime}
                                                        renderValidationError={this.renderValidationError}
                                                        onUpdateComprehensivePaymentDetails={this.onUpdateComprehensivePaymentDetails}
                                                        onUpdateCompulsoryPaymentDetails={this.onUpdateCompulsoryPaymentDetails}
                                                        onUpdateRidersPaymentDetails={this.onUpdateRidersPaymentDetails}
                                                        setStateData={this.setStateData}
                                                        callingContactChecked={this.state.callingContactChecked}
                                                        setCheckboxContactCalling={this.setCheckboxContactCalling}
                                                        onChangeFromErrorToValid={this.onChangeFromErrorToValid}
                                                    />
                                                </div>
                                            </div>
                                            : <div className='loadingOffers'>
                                            </div>}
                                    </div>
                                    <div style={{display: 'flex', flexDirection: 'row', 
                                        justifyContent: this.state.clientData && this.state.SelectedTab == "tab-content-1" ? 'space-between' : 'flex-end',
                                         alignItems: 'center', padding: '10px 20px'}}>
                                        {this.state.clientData && this.state.SelectedTab == "tab-content-1" &&
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            <button
                                                className="update-client-details-button pointer"
                                                onClick={this.setIsClientDetailsEditTrue}
                                            >עדכון פרטי לקוח</button>

                                        </div>
                                        }

                                        <div className="popup-bottom-row">
                                            {(this.state.productionData.productionMode == 0 &&
                                                moment(this.state.productionData.startDate).tz("Israel").format('YYYY-MM-DDTHH:mm:ss').split('T')[0] >= moment(new Date()).tz("Israel").format('YYYY-MM-DDTHH:mm:ss').split('T')[0])
                                                // new Date(this.state.productionData.startDate).toISOString().split('T')[0] >= new Date().toISOString().split('T')[0])
                                                ? <>
                                                    < button onClick={(e: any) => this.saveProduction()} className="button blue" disabled={this.state.hasClickToSaveAndProduction ? true : false} >
                                                        שמור
                                                    </button>


                                                    {this.state.SelectedTab == "tab-content-5" && <button onClick={(e: any) => this.makeProduction()} className="button blue" disabled={this.state.hasClickToSaveAndProduction ? true : false}>
                                                        הפק טיוטה
                                                    </button>

                                                    }
                                                </> : ""}


                                            <button onClick={(e: any) => this.closeProduction()} className="button outline">
                                                ביטול
                                            </button>
                                            {this.state.SelectedTab != "tab-content-5" && <button onClick={(sign: any) => this.nextTab("+")} className="button green" disabled={this.state.SelectedTab == "tab-content-5" ? true : false}
                                            >
                                                {"הבא >>"}
                                            </button>}
                                            {this.state.SelectedTab != "tab-content-1" && <button onClick={(sign: any) => this.nextTab("-")} className="button green" disabled={this.state.SelectedTab == "tab-content-1" ? true : false}
                                            >
                                                {"<< הקודם"}
                                            </button>}
                                        </div>
                                    </div>

                                    {this.state.saveLoading && (
                                        <PleaseWaitLayer />
                                    )}

                                </>) : (

                                <DateOfProductionIsLate
                                    goToSimulator={this.props.onGoToSimulatorClick}
                                    onClose={() => this.setState({ showModel: false })}
                                    leadId={this.state.productionData.offer.leadId}
                                    navigateToSmilator={(e: any) => { this.closeProduction() }}

                                />
                            )}
                        </div>
                    </div >

                ) : ""
                }
            </>
        );
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatch,
        setReloadLeads: (reload: boolean) => dispatch(setReloadLeads(reload)),
    };
}

const mapStateToProps = (state: RootState) => ({
    agreementData: state.policyProduction ? state.policyProduction.agreementCheckboxesData : "",
});

export default connect(mapStateToProps, mapDispatchToProps)(OfferProduction);